import { render, staticRenderFns } from "./tz_detail.vue?vue&type=template&id=061e4b08&scoped=true&"
import script from "./tz_detail.vue?vue&type=script&lang=js&"
export * from "./tz_detail.vue?vue&type=script&lang=js&"
import style0 from "./tz_detail.vue?vue&type=style&index=0&id=061e4b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e4b08",
  null
  
)

export default component.exports